import axios from 'axios'
import { useEffect, useState } from 'react'
import type { OemRequestRow, SupplierTab } from './SupplierList.types'

export function useOemRequestData(activeTab: SupplierTab, page: number, pageSize: number) {
  const [rows, setRows] = useState<OemRequestRow[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [totalCount, setTotalCount] = useState(0)

  async function load() {
    setLoading(true)
    setError(null)

    try {
      const { data } = await axios.get<{ count: number; list: OemRequestRow[] }>('/supplier/oem-request', {
        params: { page, pageSize },
      })

      setRows(data.list)
      setTotalCount(data.count)
    } catch (err) {
      console.error(err)
      setError('Failed to load OEM requests')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (activeTab !== 'oemsPending') return
    load()
  }, [activeTab, page, pageSize])

  return { rows, setRows, loading, error, totalCount }
}
